import { gql } from '@apollo/client';

const ProductionOrderInfo = gql`
  fragment ProductionOrderInfo on ProductionOrder {
    id
    account {
      id
      accountNumber
      accountAddresses {
        id
        address
        address2
        city
        region
        postalCode
        country
        isShipping
        isDefault
      }
    }
    address
    arches
    createdAt
    customerState
    hexCode
    importOrderType
    legacyId
    legacyShipmentContext {
      orderStatus
      shipmentStatus
      subscriptionStatus
    }
    lowerArchQuantity
    manufacturerActivities {
      id
      status
      eventType
      message
      createdAt
    }
    manufacturerId
    manufacturerCompletedAt
    manufacturerDiscardAt
    manufacturerInProcessAt
    manufacturerInTransitAt
    manufacturerOnHoldAt
    manufacturerState
    order {
      id
      hexCode
    }
    partnerLocation {
      id
      name
      partnerShippingAddress {
        id
        address
        address2
        city
        region
        postalCode
        country
      }
    }
    partnerState
    patient {
      id
      firstName
      lastName
      dob
      birthDay
      birthMonth
      birthYear
    }
    patientSettings
    productionNotes
    productionOrderItemsAttributes {
      id
      name
      quantity
      trackingNumber
      eta
      deliveredAt
      trackingUrl
      labelUrl
      manufacturerExternalId
      shippingCarrier {
        id
        name
      }
      shippingCarrierId
      product {
        id
        name
        featuredImage
        warrantyAllowed
      }
      patient {
        id
        firstName
        lastName
        dob
      }
    }
    projectedDeliveredAt
    referral {
      id
      hexCode
      source
      state
      sentAt
      consumedAt
      createdAt
    }
    sendToClinic
    sentToExternalManufacturer
    sentToExternalManufacturerAt
    state
    addressEditable
    updatedAt
    upperArchQuantity
    user {
      id
      firstName
      lastName
      email
      phone
    }
    warrantyId
    warranty {
      id
      hexCode
    }
    warranties {
      id
      hexCode
    }
    disableWarranty
  }
`;

export default ProductionOrderInfo;
